import { createFileRoute } from '@tanstack/react-router';

import RequestPasswordRoute from '~/features/auth/routes/RequestPassword.route';

export const Route = createFileRoute('/_auth/request/password/')({
    component: () => <RequestPasswordRoute />,
});
